import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useState } from 'react'
// import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { PropTypes } from 'prop-types'
import { useEffect } from 'react'
import Icons from 'assets/icons'
import Button from 'components/formElements/Button'
import { useRequest } from 'hooks/useRequest'
import moment from 'moment';
import useToast from 'hooks/useToast'
import { useDispatch, useSelector } from 'react-redux'
import useEditor from 'hooks/useEditor'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useParams } from 'react-router-dom';
import { currencyFormatter } from 'utils/CurrencyFormatter';
import { setEdittedRow } from 'redux/features/projectDetail/projectDetailSlice';
const Rate = (props) => {
    const { projectDetail } = useSelector((state) => state)
    const { projectId } = useParams()
    const dispatch = useDispatch()
    const [addRateDialog, setAddRateDialog] = useState(false);
    const [projectRate, setProjectRate] = useState([]);
    const [request, loading] = useRequest()
    const { showToast } = useToast()
    const { project, edittedRow } = projectDetail
    const { calendarEditor, rowEditorBody, currencyEditor } = useEditor()
    const [date3, setDate3] = useState(project?.rates?.periodStart);
    const [date, setDate] = useState(null);
    const [value, setValue] = useState(null);
    const [value11, setValue11] = useState({ name: 'TL', code: 'TL' });

    useEffect(() => {
        props.setWidth("80vw")
    }, [])

    const invoicesFunc = () => {
        request('/ProjectRates/GetProjectRateById', {
            method: 'GET', params: { id: projectId }
        }).then((res) => {
            if (res?.data?.result) {
                props.setCurrentRate(res.data.result?.find(d => props.checkBetween(moment(new Date(), 'YYYY-MM-DD'), moment(d.periodStart).format('YYYY-MM-DD'), moment(d.periodEnd).format('YYYY-MM-DD'))))
                setProjectRate(res.data.result)
            }
            dispatch(setEdittedRow({}))
        })
    }

    useEffect(() => {
        invoicesFunc()
    }, [])

    const checkBetween = (betweenDate, startDate, endDate) => {
       return moment(betweenDate).isBetween(startDate,endDate)
    }

    const addProjectRate = () => {
        let start = projectRate?.find(d => true == checkBetween( moment(date3).format('YYYY-MM-DD'), moment(d.periodStart).format('YYYY-MM-DD'), moment(d.periodEnd).format('YYYY-MM-DD')));
        let end = projectRate?.find(d => true == checkBetween(moment(date).format('YYYY-MM-DD'), moment(d.periodStart).format('YYYY-MM-DD'), moment(d.periodEnd).format('YYYY-MM-DD')));
        if (start !== undefined || end !== undefined) {
            showToast('Girilen Rate Aralığı Daha Önce Eklenmiştir!', 'warning')

        } else {
            if (value11 != null && projectId != null &&
                value != null && date3 != null && date != null) {
                let rate = {
                    "projectId": projectId,
                    "currency": value11.code,
                    "budget": value,
                    "periodStart": date3,
                    "periodEnd": date
                }
                request('/ProjectRates/AddProjectRates', {
                    method: 'POST', data: rate
                }).then((res) => {
                    if (res?.data) {
                        showToast('Rate Bilgisi Eklendi!', 'success')
                        setAddRateDialog(false)
                        props.setWidth("80vw")
                        invoicesFunc()
                        setDate3(null)
                        setDate(null)
                        setValue(null)
                        setValue11(null)
                    }
                })
            } else {
                showToast('Tüm Alanları Doldurun!', 'warning')
            }
        }


    }

    const acceptFunc = (rowData) => {
        let deleteData = {
            "id": rowData.id
        }
        request('/ProjectRates/DeleteProjectRates', {
            method: 'DELETE', data: deleteData
        }).then((res) => {
            if (res?.data) {
                showToast('Rate silme işlemi tamamlandı.', 'success')
                invoicesFunc()
            }
        })
    }
    const buttonTemplate = (rowData) => {
        return (
            <Icons.deleteNotFill
                onClick={() => {

                    confirmDialog({
                        message: 'Kaydı silmek istiyor musunuz?',
                        header: '',
                        icon: 'pi pi-info-circle',
                        acceptClassName: 'p-button-danger',
                        accept: () => acceptFunc(rowData),

                    });


                }}
                size={20}
                className='text-danger cursor-pointer'
            />
        );

    };
    const onRowEditComplete1 = async (e) => {
        let _products2 = [...projectRate];
        let { index } = e;
        _products2[index] = edittedRow;

        const startUpdate = projectRate?.filter((r,i) => i !=index)?.find(d => true == checkBetween( moment(edittedRow.periodStart).format('YYYY-MM-DD'), moment(d.periodStart).format('YYYY-MM-DD'), moment(d.periodEnd).format('YYYY-MM-DD')));
        const endUpdate = projectRate?.filter((r,i) => i !=index)?.find(d => true == checkBetween( moment(edittedRow.periodEnd).format('YYYY-MM-DD'), moment(d.periodStart).format('YYYY-MM-DD'), moment(d.periodEnd).format('YYYY-MM-DD')));

        if (startUpdate !== undefined || endUpdate !== undefined) {
            showToast('Girilen Rate Aralığı Daha Önce Eklenmiştir!', 'warning')
            invoicesFunc()
        } else {
            request('/ProjectRates/UpdateProjectRates', {
                method: 'Put', data: edittedRow
            }).then((res) => {
                if (res?.data) {
                    showToast('Rate Bilgileri Güncellendi.', 'success')
                    invoicesFunc()
                }
                dispatch(setEdittedRow({}))
            })
        }

    }


    const currency = [
        { name: 'TL', code: 'TL' },
        { name: 'USD', code: 'USD' },
        { name: 'EUR', code: 'EUR' },
        { name: 'GBP', code: 'GBP' },
    ];
    const openDialogFunc = () => {
        setAddRateDialog(true)
        props.setWidth("25%")
    }
    const closeDialogFunc = () => {
        setAddRateDialog(false)
        props.setWidth("80vw")
        setDate3(null)
        setDate(null)
        setValue(null)
        setValue11(null)
    }

    return (

        !addRateDialog ? <div>

            <ConfirmDialog />
            < div className="card" >
                <Button className='btn-bill' title='Rate Ekle' handleClick={openDialogFunc}
                    icon={<Icons.plus size={17} />}
                    style={{
                        display: "block", marginLeft: "auto",
                        marginRight: "0"
                    }} />
                <DataTable size="small"
                    emptyMessage='Hiç Kayıt Bulunamadı'
                    loading={loading}
                    onRowEditInit={e => dispatch(setEdittedRow(e.data))}
                    responsiveLayout="stack" value={projectRate} editMode="row" dataKey="id" onRowEditComplete={onRowEditComplete1} >
                    <Column
                        className='text-semi-bold text-sm'
                        headerClassName='text-bold bg-primary text-default'
                        field="periodStart"
                        header="Periyot Başlangıç Tarihi"
                        editor={(options) => calendarEditor(options)}
                        style={{ width: 'auto' }} dataType="date"
                        body={(rowData) => {
                            const periodStart = moment(rowData.periodStart).format('LL')
                            return (
                                <span>{periodStart}</span>
                            )
                        }}

                    />
                    <Column
                        className='text-semi-bold text-sm'
                        headerClassName='text-bold bg-primary text-default'
                        field="periodEnd"
                        header="Periyot Bitiş Tarihi"
                        sortable="true"
                        editor={(options) => calendarEditor(options)}
                        style={{ width: 'auto' }}
                        body={(rowData) => {
                            const periodEnd = moment(rowData.periodEnd).format('LL')
                            return (
                                <span>{periodEnd}</span>
                            )
                        }}
                    />
                    <Column
                        className='text-semi-bold text-sm'
                        headerClassName='text-bold bg-primary text-default'
                        field="budget"
                        header="Rate"
                        sortable="true"
                        editor={(options) => currencyEditor(options)}
                        style={{ width: 'auto' }}
                        body={(rowData) => {
                            return (
                                <span>{currencyFormatter(rowData.budget)} {rowData.currency}</span>
                            )
                        }}
                    />
                    <Column
                        className='text-semi-bold text-sm'
                        headerClassName='text-bold bg-primary text-default'
                        rowEditor
                        body={(row, d) => rowEditorBody(d)}
                        style={{ width: '2.5rem' }}
                    />
                    <Column className='text-semi-bold'
                        body={(rowData) => buttonTemplate(rowData)}
                        style={{ width: "2.5rem" }} />
                </DataTable>
            </div >

        </div > :
            <div>
                <div className="card" style={{ display: "flex", alignItems: "center" }}>

                    <div className="field w-100">
                        <Calendar placeholder='Başlangıç Tarihi'
                            id="icon" className="w-100"
                            dateFormat='dd/mm/yy'
                            tooltipOptions={{ position: 'top' }}
                            value={date3 && new Date(date3)} onChange={(e) => setDate3(moment(e.value).add(3, 'hours').toISOString())} showIcon />

                    </div>
                    <div className="field w-100">
                        <Calendar dateFormat='dd/mm/yy'
                            placeholder='Bitiş Tarihi' id="icon" className="w-100" value={date && new Date(date)} onChange={(e) => setDate(moment(e.value).add(3, 'hours').toISOString())} showIcon />

                    </div>
                    <div className="field w-100">
                        <InputNumber inputId="inputnumber"
                            mode="decimal" minFractionDigits={2}
                            placeholder='Rate' className="w-100" value={value} onChange={(e) => setValue(e.value)} />
                    </div>
                    <div className="field w-100">
                        <Dropdown className="w-100" placeholder='Para Birimi' inputId="dropdown" value={value11} options={currency} onChange={(e) => setValue11(e.value)} optionLabel="name" />
                    </div>
                    <Button className='btn-bill w-100' title='Ekle / Güncelle' handleClick={addProjectRate} />
                    <Button className='btn-bill w-100' title='Vazgeç' handleClick={closeDialogFunc} />
                </div>
            </div >
    )
}
Rate.propTypes = {
    setWidthFunc: PropTypes.func,
};
export default Rate
